export var isFunction = function (target) { return typeof target === 'function'; };
//# sourceMappingURL=type.js.map